var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/take5/stop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/take5/stop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2705652,10.7505046 C33.7136007,10.7781306 34.8748642,11.9565793 34.8748642,13.4062943 L34.8748642,23.3910728 C34.8748642,24.2078547 34.7229862,25.5161326 34.5358948,26.3112547 L32.7756146,33.7925754 C32.4368398,35.2323684 31.1519727,36.2499899 29.6728808,36.2499899 L16.5517115,36.2499899 C15.6557481,36.2499899 14.5008398,35.6618679 13.9738711,34.9373023 L5.63322709,23.468633 C4.77040185,22.2821429 5.03271888,20.6208882 6.21901442,19.7580629 C7.40556936,18.8951728 9.0668241,19.1575547 9.92958449,20.3439151 L12.0312335,23.2338771 L12.0312335,7.56255826 C12.0312335,6.11284324 13.1925619,4.93439452 14.6355974,4.90676854 C16.1247411,4.87829953 17.3437209,6.12555379 17.3437209,7.61502167 L17.3437209,19.2500304 L17.8749696,19.2500304 L17.8749696,4.9063146 C17.8749696,3.45659958 19.036298,2.27815085 20.4793335,2.25052488 C21.9684771,2.22205586 23.1874569,3.46931012 23.1874569,4.958778 L23.1874569,19.2500304 L23.7187057,19.2500304 L23.7187057,7.49615217 C23.7187057,6.04643715 24.8800341,4.86798842 26.3230696,4.84036245 C27.8122132,4.81189343 29.031193,6.05914769 29.031193,7.54861558 L29.031193,19.2500304 L29.5624417,19.2500304 L29.5624417,13.4587577 C29.5624417,11.9692899 30.7814215,10.7220356 32.2705652,10.7505046 Z",
    id: "hand",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.cee554e5.svg";
export { ForwardRef as ReactComponent };